module.exports = __webpack_public_path__ + "img/37360-083.03a800f5.jpg";